import { BrokerageUserSearchRequestParams, BrokerageUserSearchRequestQuery } from '@lio/api-types';
import { BrokerageUserSearchResponseWithPagination } from '@services/brokerage/brokerage.types';
import { getBrokerageUsersQuery } from '@services/brokerage/user/userQuery';
import { useInfiniteQuery } from '@tanstack/react-query';
import { useClient } from '@utils/api-client';
import { brokerageUserKeys } from './user.keys';

export const useSearchPaginatedBrokerageUsers = (
  requestParams?: BrokerageUserSearchRequestParams,
  requestQuery?: BrokerageUserSearchRequestQuery,
  { enabled } = { enabled: true },
) => {
  const client = useClient();
  const query = getBrokerageUsersQuery(requestQuery ?? {});
  const result = useInfiniteQuery({
    queryKey: brokerageUserKeys.searchPaginated(requestParams ?? {}, query),
    queryFn: ({ pageParam }) =>
      client
        .get(`brokerage/${requestParams?.brokerageId}/user?${query}&pageOffset=${pageParam}`)
        .json<BrokerageUserSearchResponseWithPagination>(),
    enabled: Boolean(requestParams?.brokerageId) && enabled,
    initialPageParam: 0,
    staleTime: 0,
    gcTime: 0,
    placeholderData: (previousData) => previousData,
    refetchOnWindowFocus: false,
    retry: false,
    getNextPageParam: (lastPage, allPages) => {
      if (!lastPage?.pagination) return undefined;
      if (!lastPage.pagination.pageLimit) return undefined;
      if (!lastPage.pagination.total) return undefined;
      const { total, pageLimit } = lastPage.pagination;
      const fetchedPageCount = allPages.length;
      const nextPageOffsetValue = fetchedPageCount * pageLimit;
      if (nextPageOffsetValue > total) return undefined;
      return nextPageOffsetValue;
    },
  });
  return { ...result, brokerageUsers: result.data };
};
